module.exports = __webpack_public_path__ + "img/Alcohol.5f50a1a3.jpg";